import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 14,
	viewBox: "0 0 13 14",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: "#95A0AF",
			d: "M7.112 3.148c0-.267-.346-.481-.612-.481-.268 0-.608.215-.608.481v3.259H2.648c-.267 0-.481.327-.481.593 0 .268.215.636.481.636h3.244v3.216c0 .267.342.481.608.481.268 0 .612-.215.612-.481V7.636h3.24c.267 0 .481-.37.481-.636 0-.268-.215-.593-.481-.593h-3.24z"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#CAD5E3",
			d: "M0 12.2V1.8C0 1.082.58.5 1.3.5h10.4c.718 0 1.3.58 1.3 1.3v10.4c0 .718-.58 1.3-1.3 1.3H1.3c-.718 0-1.3-.58-1.3-1.3M11.7 1.8H1.3v10.4h10.4z"
		})]
	})
});
export default SvgPlus;
